import React from "react";
import { Form, Input, Button, Typography, Checkbox, message } from "antd";
import CardComponent from "@/components/card";
import { userDeleteRequest } from "@/services/common/dataDeletionRequest";
import { getIsLoggedIn, setCurrentForm, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch, useSelector } from "react-redux";

const { Title, Paragraph } = Typography;

const DataDeletionRequestForm = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const dispatch = useDispatch();
  const onFinish = async (values) => {
    if (!isLoggedIn) {
      dispatch(setModalOpen(true));
      dispatch(setCurrentForm("signIn"));
      return;
    }
    const payload = {
      name: values.fullName, // Passing full name but not storing
      contactEmail: values.email, // Storing only email
      reason: values.reason || "", // Optional reason
    };

    try {
      const response = await userDeleteRequest(payload);
      message.success(response.message);
    } catch (error) {
      message.error("An error occurred. Please try again.");
    }
  };

  return (
    <div className="data-deletion-form">
      <CardComponent>
        <Title level={3}>Request for Data Deletion</Title>
        <Paragraph>
          If you wish to delete your personal data from our records, please fill out the form below.
          We will process your request within 30 days as per GDPR regulations.
        </Paragraph>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Full Name"
            name="fullName"
            rules={[{ required: true, message: "Please enter your full name" }]}
          >
            <Input placeholder="Enter your full name" />
          </Form.Item>

          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              { required: true, message: "Please enter your email address" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>

          <Form.Item label="Reason for Deletion" name="reason">
            <Input.TextArea
              placeholder="Explain why you want to delete your data (optional)"
              autoSize={{ minRows: 4, maxRows: 10 }}
            />
          </Form.Item>

          <Form.Item
            name="confirm"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject("You must confirm to proceed"),
              },
            ]}
          >
            <Checkbox>
              I understand that my account and all associated data will be permanently deleted.
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit Request
            </Button>
          </Form.Item>
        </Form>
      </CardComponent>
    </div>
  );
};

export default DataDeletionRequestForm;
